export const SettingsTabs = {
    RATINGS: 'ratings',
    GENERAL: 'general',
    MEMBERS: 'members',
    ANNOUNCEMENT: 'Announcement',
};
